import React, { useState } from 'react';
import { Typography, TextField, Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer } from '@mui/material';
import DateRangeFilter, { defaultStart, defaultEnd } from './DateRangeFilter';
import { ReportSearch } from '../../../api';
import dayjs from 'dayjs';

const SearchReport = ({ access }) => {
  const [start, setStart] = useState(defaultStart());
  const [end, setEnd] = useState(defaultEnd());
  const [query, setQuery] = useState('');
  const [rows, setRows] = useState([]);

  const run = () =>
    ReportSearch(access?.org?.id, { start, end, q: query }).then(setRows).catch(() => {});

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>Search</Typography>
      <DateRangeFilter start={start} end={end} onStart={setStart} onEnd={setEnd} onSubmit={run}
        extra={<TextField label="Search" size="small" value={query} onChange={e => setQuery(e.target.value)} />}
      />
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Owner</TableCell>
              <TableCell>Pet</TableCell>
              <TableCell>Time In</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Acknowledged</TableCell>
              <TableCell>Checked Out</TableCell>
              <TableCell>Comment</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id}>
                <TableCell>{r.ownerName}</TableCell>
                <TableCell>{r.petName}</TableCell>
                <TableCell>{dayjs(r.createdAt).format('MM/DD/YY h:mm A')}</TableCell>
                <TableCell>{[r.reason?.label, r.subreason?.label].filter(Boolean).join(' / ')}</TableCell>
                <TableCell>{r.acknowledgedAt ? dayjs(r.acknowledgedAt).format('h:mm A') : '—'}</TableCell>
                <TableCell>{r.completedAt ? dayjs(r.completedAt).format('h:mm A') : '—'}</TableCell>
                <TableCell>{r.comment}</TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={7} align="center">No results</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SearchReport;
